export default __webpack_public_path__ + "static/media/backgroundImage.0282aa7c.jpg";